import axios from "axios";
import { settings as s } from "../Settings";

const getUrl = (ep) => `${s.baseUrl}${ep}`;

export const postDataAnonymously = async (relativeUrl, data) => {
  const url = getUrl(relativeUrl);
  const config = {
    method: "post",
    url,
    headers: {
      "Content-Type": "application/json-patch+json",
      Accept: "*/*",
    },
    data,
  };

  try {
    const response = await axios(config)
      .then((res) => res)
      .catch((error) => error.response);
    return response;
  } catch (err) {
    return { status: null };
  }
};
// get Data
const controllersMap = new Map(); // 🔹 store controllers per URL

// export const getData = async (relativeUrl) => {
//   const accessToken = localStorage.getItem("access_token");
//   const url = getUrl(relativeUrl);

//   // 🧠 Agar same URL ki koi pending request hai → cancel karo
//   if (controllersMap.has(url)) {
//     const prevController = controllersMap.get(url);
//     prevController.abort();
//     console.warn("⚠️ Canceled previous request for:", url);
//   }

//   // Create new controller for current request
//   const controller = new AbortController();
//   controllersMap.set(url, controller);

//   const config = {
//     headers: {
//       Authorization: `Bearer ${accessToken}`,
//       "Content-Type": "application/json-patch+json",
//       Accept: "*/*",
//     },
//     signal: controller.signal,
//   };

//   try {
//     const response = await axios.get(url, config);
//     return { status: response.status, data: response.data };
//   } catch (error) {
//     if (axios.isCancel(error) || error.name === "CanceledError") {
//       console.warn("❌ Request canceled:", url);
//       return { status: 0, data: [] };
//     }

//     if (error.response) {
//       console.error("⚠️ API error:", error.response.status, url);
//       return { status: error.response.status, data: [] };
//     }

//     console.error("⚠️ Network error:", error.message);
//     return { status: 0, data: [] };
//   } finally {
//     // ✅ Request complete → remove from map
//     controllersMap.delete(url);
//   }
// };

export const getData = async (relativeUrl) => {
  const accessToken = localStorage.getItem("access_token");
  const url = getUrl(relativeUrl);

  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json-patch+json",
      Accept: "*/*",
    },
  };

  try {
    const response = await axios.get(url, config);
    return { status: response.status, data: response.data };
  } catch (error) {
    if (axios.isCancel(error) || error.name === "CanceledError") {
      console.warn("❌ Request canceled:", url);
      return { status: 0, data: [] };
    }

    if (error.response) {
      console.error("⚠️ API error:", error.response.status, url);
      return { status: error.response.status, data: [] };
    }

    console.error("⚠️ Network error:", error.message);
    return { status: 0, data: [] };
  }
};

// Like getData, but PRESERVES the backend error body on a non-2xx response
// (getData replaces it with []), so callers can read the server's {error:"..."}
// message. Use this where the exact backend reason matters — e.g. the RingCentral
// extension allocation, which distinguishes a 409 "pool full" from a 400
// provisioning/JWT failure and needs the failure text to be visible.
export const getDataWithError = async (relativeUrl) => {
  const accessToken = localStorage.getItem("access_token");
  const url = getUrl(relativeUrl);

  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json-patch+json",
      Accept: "*/*",
    },
  };

  try {
    const response = await axios.get(url, config);
    return { status: response.status, data: response.data };
  } catch (error) {
    if (axios.isCancel(error) || error.name === "CanceledError") {
      return { status: 0, data: null };
    }
    if (error.response) {
      // Keep the real body ({ success:false, error:"..." }) instead of [].
      return { status: error.response.status, data: error.response.data };
    }
    return { status: 0, data: null };
  }
};

// post data
export const postData = async (relativeUrl, data) => {
  const accessToken = localStorage.getItem("access_token");
  const url = getUrl(relativeUrl);
  const config = {
    method: "post",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
      Accept: "*/*",
    },
    data,
  };
  try {
    const response = await axios(config)
      .then((resp) => resp)
      .catch((error) => error);
    return response;
  } catch (err) {
    return { status: null };
  }
};
// put data
export const putData = async (relativeUrl, user, data) => {
  const url = getUrl(relativeUrl);
  const config = {
    method: "put",
    url,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({ ...data }),
  };

  try {
    const response = await axios(config)
      .then((res) => res)
      .catch((error) => error);
    return response;
  } catch (err) {
    return { status: null };
  }
};

export const postFormData = async (relativeUrl, data, customConfig = {}) => {
  const accessToken = localStorage.getItem("access_token");
  const url = getUrl(relativeUrl);

  const config = {
    method: "post",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: "*/*",
    },
    data,
    ...customConfig,
  };

  try {
    const response = await axios(config);
    return response;
  } catch (err) {
    return { status: null };
  }
};
